import sensors from '@/util/dataTrack'

const clkValueMap = new Map()
const expValueMap = new Map()

export function watchExpo(el, eventName, bindingValue) {
	if (!expValueMap.has(el)) {
		let status = { inViewport: false, scrollStop: true }

		expValueMap.set(el, bindingValue)

		function track() {
			if (status.inViewport && status.scrollStop) {
				// 需要同时满足出现在视口中和滚动停止两个条件

				sensors.track(eventName, expValueMap.get(el))
				// 避免埋点反复生效,将状态复位
				status.inViewport = false
			}
		}

		status.inViewport = false
		status.scrollStop = true

		if (window.IntersectionObserver) {
			new IntersectionObserver(
				([entry]) => {
					if (entry.isIntersecting) {
						// 进入视口
						status.inViewport = true
						track()
					} else {
						status.inViewport = false
					}
				},
				{
					threshold: 0.5
				}
			).observe(el)
		}

		let timeout = null
		function onParentScroll() {
			if (status.scrollStop) {
				status.scrollStop = false
			}

			if (timeout) {
				clearTimeout(timeout)
			}
			timeout = setTimeout(() => {
				status.scrollStop = true
				track()
			}, 100)
		}
		el.__sd_scrollParents = []
		el.__sd_scrollCallback = onParentScroll
		let parent = el.parentNode

		while (!!parent) {
			parent.addEventListener('scroll', onParentScroll)
			el.__sd_scrollParents.push(parent)

			parent = parent.parentNode
		}
	} else {
		expValueMap.set(el, bindingValue)
	}
}

export function watchClick(el, eventName, bindingValue) {
	if (!clkValueMap.has(el)) {
		clkValueMap.set(el, bindingValue)

		el.addEventListener(
			'click',
			() => {
				sensors.track(eventName, clkValueMap.get(el))
			},
			true
		)
	} else {
		clkValueMap.set(el, bindingValue)
	}
}

export default {
	install(vue) {
		vue.directive('sd-clk', {
			bind(el, binding) {
				watchClick(el, binding.arg, binding.value)
			},
			update(el, binding) {
				watchClick(el, binding.arg, binding.value)
			}
		})

		vue.directive('sd-exp', {
			inserted(el, binding) {
				watchExpo(el, binding.arg, binding.value)
			},
			update(el, binding) {
				watchExpo(el, binding.arg, binding.value)
			},
			unbind(el) {
				if (el.__sd_scrollParents && el.__sd_scrollCallback) {
					el.__sd_scrollParents.forEach(parent => {
						try {
							parent.removeEventListener('scroll', el.__sd_scrollCallback)
						} catch (e) {}
					})
				}
			}
		})

		vue.prototype.$sensors = sensors
	}
}
